/** Datenschutzstatus einer Person (Backend: privacyStatus). */
export const PRIVACY_STATUS = {
  normal: "normal",
  erasureRequested: "erasure_requested",
  anonymized: "anonymized"
} as const;
export type PrivacyStatus = typeof PRIVACY_STATUS[keyof typeof PRIVACY_STATUS];

/** Kanal, über den ein Datenschutzvorgang erfasst wurde. */
export const PRIVACY_CHANNEL = {
  studio: "studio",
  app: "app",
  web: "web"
} as const;

/** Aktionen des Datenschutz-Drawers; zugleich Schlüssel des laufenden Speichervorgangs. */
export const PRIVACY_ACTION = {
  notice: "notice",
  request: "request",
  complete: "complete"
} as const;
